import DOMPurify from 'dompurify';
import { marked } from 'marked';

/**
 * @param dangerouslyReturnHtml Allow to return html without sanitizing it in unsupported environments.
 */
export const toHTML = (markdown, dangerouslyReturnHtml = false) => {
  const html = marked.parse(markdown ?? '', {
    mangle: false,
    headerIds: false,
    breaks: true
  });
  if (DOMPurify.isSupported) {
    return DOMPurify.sanitize(html);
  }
  if (dangerouslyReturnHtml) {
    return html;
  }
  throw new Error('DOMPurify.sanitize is in the current environment not supported.');
};